






























































































































































































































































































































































import { GeekItem } from '@/models';
import { Department, LevelEntity, NewOpportunity, Opportunity } from '@/models/opportunities';
import { opportunityFormMixin } from '@/shared';
import { Actions, typedStore } from '@/store';
import { ToastsService } from '@/utils';
import mixins from 'vue-typed-mixins';
import moment from 'moment';

export default mixins(opportunityFormMixin).extend({
  name: 'OpportunityEditView',
  data() {
    return {
      isFormChanged: false,
      approversLimit: 2,
    };
  },
  async created() {
    this.loader.isOpportunityCreateRequestSending = true;
    try {
      await this.$store.dispatch(Actions.opportunities.fetchCurrent, this.$route.params.id);
      this.updateForm();
    } finally {
      this.loader.isOpportunityCreateRequestSending = false;

      const unwatch = this.$watch('form',
        () => {
          this.isFormChanged = true;
          unwatch();
        },
        { deep: true },
      );
    }
  },
  methods: {
    updateForm() {
      const {
        id,
        level,
        department,
        members,
        createdAt,
        issuer,
        selfMembershipStatus,
        status,
        ...formData
      } = typedStore(this).state.opportunities.current;

      this.form = {
        ...formData,
        departmentId: (this.departments.find(d => d.name === department) as Department).id,
        levelId: (this.levels.find(l => l.name.toLowerCase() === level.toLowerCase()) as LevelEntity).id,
        startDate: moment(formData.startDate).toDate(),
        endDate: moment(formData.endDate).toDate(),
      } as NewOpportunity;
    },
    async checkForm() {
      const isFormValid = await this.$validator.validate();

      if (!isFormValid) {
        return;
      }
      const outputTags = this.form.tags.map(t => t.id ? { id: t.id } : { value: t.value });
      const outputApprovers = this.form.approvers.map(a => a.id);
      const newOpportunity = {
        id: this.$route.params.id,
        ...this.form,
        tags: outputTags,
        approvers: outputApprovers,
      };

      this.loader.isOpportunityCreateRequestSending = true;
      try {
        await this.$store.dispatch(Actions.opportunities.edit, newOpportunity);
        ToastsService.success(this.$t('opportunities.edit.form.notifications.edit-success') as string);
        this.$router.push({ name: 'opportunity-details', params: { id: this.$route.params.id } });
      } finally {
        this.loader.isOpportunityCreateRequestSending = false;
      }
    },
  },
});
